<template>
    <div class="content-wrapper">
        <div class="">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <app-breadcrumb page-title="Product Approval" />
                </div>
                <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                    <div v-if="this.$can('view_list_student_studentprofile_tab_finance_create_invoice')" class="float-md-right mb-3 mb-sm-3 mb-md-0">
                        <button type="button" class="btn btn-primary btn-with-shadow" @click="openAddEditModal">
                            Create
                        </button>
                    </div>
                </div>
            </div>
            <app-table :id="tableId" :options="options" @action="getListAction" />

            <product-approval-form-wizard v-if="isAddEditModalActive" :modal-id="formId" :table-id="tableId" @close-modal="closeAddEditModal" />
                
            <app-delete-modal
                v-if="deleteConfirmationModalActive"
                :preloader="deleteLoader"
                modal-id="demo-delete"
                @confirmed="deleteConfirmed"
                @cancelled="deleteCancelled"
            />

            <product-approval-form-approval
                v-if="confirmModalApproval"
                :table-id="tableId"
                :form-id="formIdApproval"
                :modal-title="modalApprovalTitle"
                :selected-url="selectedApprovalUrl"
                :confirm-invoice-id="Number(confirmInvoiceId)"
                :confirm-approval-status-id="Number(confirmApprovalStatusId)"
                @close-modal="cancelConfirmApproval"
            />
            
            <modal-view-p-d-f v-if="showPDF" :selected-url="pdfUrl" @close-modal="closeModalViewPdf" />
        </div>
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import { Schema } from "./Schema.js";
import ModalViewPDF from "../InvoiceRequest/ModalViewPDF.vue";
import ProductApprovalFormWizard from "./ProductApprovalFormWizard.vue";
import ProductApprovalFormApproval  from "./ProductApprovalFormApproval.vue";
import { INVOICE_HISTORY_V2 } from "../../../../Config/ApiUrl.js";

export default {
    name: "ProductApproval",
    components: { ModalViewPDF, ProductApprovalFormWizard, ProductApprovalFormApproval },
    extends: CoreLibrary,
    inject: ["eventHub"],
    mixins: [Schema],
    props: {
        value: {
            type: Object,
            default: () => {
                return {
                    code: "",
                    name: "",
                    is_active: "",
                };
            },
        },
    },
	created() {
		this.options.columns = [...this.tableColumns/*, this.actionObj*/];
	},
	mounted() {
		window.__approveInvoiceStatus = (invoiceId, approvalStatusId) => {
            this.modalApprovalTitle = 'Approve';
			this.handleApprove(invoiceId, approvalStatusId);
		};
		window.__rejectInvoiceStatus = (invoiceId, approvalStatusId) => {
            this.modalApprovalTitle = 'Reject';
			this.handleReject(invoiceId, approvalStatusId);
		};
	},
    methods: {
        resetData() {
            this.rowData = {};
            this.selectedUrl = "";
        },
        closeModalViewPdf() {
            this.showPDF = false;
        },
        openAddEditModal() {
            this.isAddEditModalActive = true;
        },
        closeAddEditModal() {
            $("#" + this.formId).modal("hide");
            this.isAddEditModalActive = false;
            this.resetData();
        },
		/**
		 * Open deletion confirmation modal
		 */
		openDeleteModal() {
			this.deleteConfirmationModalActive = true;
		},
		deleteConfirmed() {
			let url = this.Endpoint + "/" + this.rowData.id;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.cancelled();
					this.$toastr.s(response.data.message);
				})
				.catch(({ error }) => {
					// Trigger after error
				})
				.finally(() => {
					this.$hub.$emit("reload-" + this.tableId);
				});
		},
		deleteCancelled() {
			this.deleteConfirmationModalActive = false;
			this.resetData();
		},
        /**
         * $emit Form datatable action
         */
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;
            
			if (actionObj.title == this.$t("delete")) {
				this.openDeleteModal();
			// } else if (actionObj.title == this.$t("edit")) {
            //     window.location.href = `/transaction/profile-student/invoice/invoice-request-v2/` + rowData.id;
            //     this.openAddEditModal();
            } else if (actionObj.title == 'Print') {
                window.location.href = `/transaction/profile-student/invoice-v2/invoice-process/pdf/` + rowData.id;
            } else if (actionObj.title == 'View') {
                this.pdfUrl = `/transaction/invoice-request/viewPDF/${rowData.id}`;
                this.showPDF = true;
            } else if (
                actionObj.title != this.$t("delete") ||
                actionObj.title != this.$t("edit")
            ) {
                this.selectedUrl = INVOICE_HISTORY_V2 + "/" + rowData.id;
                // this.openAddEditModal();
            }
        },
		handleApprove(invoiceId, approvalStatusId) {
			this.confirmAction = "approve";
			this.selectedApprovalUrl = `${this.selectedUrl}/${invoiceId}/approve`;
			this.confirmInvoiceId = Number(invoiceId);
            this.confirmApprovalStatusId = Number(approvalStatusId);
			this.confirmModalApproval = true;
		},
		handleReject(invoiceId, approvalStatusId) {
            this.confirmAction = "reject";
            this.selectedApprovalUrl = `${this.selectedUrl}/${invoiceId}/reject`;
			this.confirmInvoiceId = Number(invoiceId);
			this.confirmApprovalStatusId = Number(approvalStatusId);
			this.confirmModalApproval = true;
		},
		cancelConfirmApproval() {
			this.confirmModalApproval = false;
			this.confirmAction = null;
			this.confirmInvoiceId = null;
			this.confirmApprovalStatusId = null;
            this.$hub.$emit("reload-" + this.tableId);
  			this.removeBackdrop(); 
		},
		removeBackdrop() {
			document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
			document.body.classList.remove('modal-open'); // kalau body masih ke-lock scroll
			document.body.style = ""; // reset style
		},
    },
};
</script>

<style scoped>
::v-deep(.datatable-th) {
    z-index: 10;
    position: relative;
}

::v-deep(.pt-primary) {
    padding-top: 0 !important;
}
</style>
